import {
  FunctionComponent,
  useState,
  useCallback,
  useEffect,
  useMemo,
} from 'react'
import { Text, Button, InputPassword } from '@conexasaude/conexa-hero'
import { PasswordStrength } from '@/pages/CreatePassword/components/PasswordStrengthBar'

import Service from '@/services/SignUpService'
import useStyles from './styles'
import { useHistory } from 'react-router-dom'
import { checkPasswordStrength } from '@/utils/password'
import { PasswordTips } from '@/pages/CreatePassword/components/PasswordTips'
import { getCache } from '@/utils/cache'
import { showErrorToast } from '@/utils/requisitionErrors'

const NewPassword: FunctionComponent = () => {
  const styles = useStyles()
  const history = useHistory()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [passwordStrength, setPasswordStrength] = useState<PasswordStrength>()

  const validateConfirm = useMemo(() => {
    return passwordStrength === 'strong' && password === confirmPassword
  }, [confirmPassword, password, passwordStrength])

  const handleErrorMessage = () => {
    if (
      confirmPassword.length >= password.length &&
      passwordStrength === 'strong' &&
      confirmPassword !== password
    )
      return 'As senhas estão diferentes.'
    return ''
  }

  const handleModifyPassword = useCallback(async () => {
    setLoading(true)
    try {
      await Service.modifyPassword(password, confirmPassword, {
        headers: {
          token: getCache('externalToken'),
        },
      })
      history.push('/senha-alterada')
    } catch (err) {
      showErrorToast(err)
    } finally {
      setLoading(false)
    }
  }, [confirmPassword, history, password])

  useEffect(() => {
    if (!password) {
      setPasswordStrength(null)
      return
    }

    const strength = checkPasswordStrength(password)

    setPasswordStrength(strength)
  }, [password])

  return (
    <div css={styles.passwordCard}>
      <Text variant="headingMedium">Criar nova senha</Text>
      <Text variant="paragraphLarge">Dicas para criar uma senha segura.</Text>

      <div css={styles.rulesPasswordWrapper}>
        <PasswordTips password={password} />
      </div>

      <InputPassword
        label="Nova senha"
        placeholder="Informe a nova senha"
        value={password}
        onChange={event => {
          setPassword(event.target.value)
        }}
        fullWidth
        strength={passwordStrength}
      />
      <div css={styles.confirmInput}>
        <InputPassword
          label="Confirmar nova senha"
          placeholder="Confirme a nova senha"
          value={confirmPassword}
          onChange={event => {
            setConfirmPassword(event.target.value)
          }}
          error={handleErrorMessage()}
          fullWidth
        />
      </div>
      <div css={styles.buttonArea}>
        <Button
          onClick={handleModifyPassword}
          busy={loading}
          disabled={!validateConfirm}
          fullWidth
        >
          Criar senha
        </Button>
      </div>
    </div>
  )
}

export default NewPassword
